import { BLOCKED_NEW_RS_COMPANIES } from '../constants/companies';

const normalize = (id) => String(id != null ? id : '').replace(/\s/g, '').toUpperCase();

export const isNewRSBlocked = (company) => {
  const id = typeof company === 'string' ? company : (company && company.id);
  if (!id) return false;
  return BLOCKED_NEW_RS_COMPANIES.map(normalize).includes(normalize(id));
};
